import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { LearningRecordPodcast, UpdatePodcastSessionRequest } from "src/types/coaching/learners";
import React, { useEffect, useMemo } from "react";

import _ from 'lodash';
import cx from 'classnames';

import { useDispatch } from "react-redux";
import {
  fetchLearningRecordPodcast,
  fetchTranscriptsForLearningPodcast,
  startPodcast,
  updatePodcastSession
} from "src/redux/actions/coaching/learners";

import userRoleService from "src/services/userRoles.service";
import PermissionDenined from "src/components/permissionDenied";
import { CourseNotFound } from "src/pages/coaching/components/notFound";

import styles from "./view.module.scss";
import { PodcastContext, PodcastContextProps } from "src/pages/coaching/components/podcast/context";
import { LoadingPodcastPage, PodcastSummaryComponent } from "src/pages/coaching/components/podcast";
import { PodcastTranscripts } from "src/types/coaching/podcast";

export const ViewPodcastPage: React.FC<object> = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const id = params.id;

  const podcast = useSelector((state: any) =>
    _.get(state.learners, `podcast[${id}].item`) as LearningRecordPodcast,
  );

  const loading = useSelector((state: any) =>
    _.get(state.learners, `podcast[${id}].loading`),
  );

  const podcastErrorCode = useSelector((state: any) => {
    return _.get(state.learners, `podcast[${id}].error.errors[0].code`);
  });

  const podcastTranscripts = useSelector((state: any) =>
    _.get(state.learners, `podcast[${id}].transcripts.item`) as PodcastTranscripts,
  );

  const [podcastContext, setPodcastContext] = React.useState<PodcastContextProps>({
    id: id,
  });

  useEffect(() => {
    if (id && !podcast) {
      dispatch(fetchLearningRecordPodcast(id));
    }

    setPodcastContext((prev) => {
      return {
        ...prev,
        id: id,
        onBack: handleBackClicked
      }
    });
  }, []);

  useEffect(() => {
    if (podcast) {

      dispatch(fetchTranscriptsForLearningPodcast(podcast.id));

      setPodcastContext((prev) => {
        return {
          ...prev,
          onBack: handleBackClicked,
          startPodcast: handleStartPodcast,
          onAnalyticsChange: handleAnalyticsChange,
        }
      });
    }
  }, [podcast]);

  useEffect(() => {
    if (podcastTranscripts) {
      setPodcastContext((prev) => {
        return {
          ...prev,
          transcripts: podcastTranscripts,
        }
      });
    }
  }, [podcastTranscripts]);

  const handleBackClicked = () => {
    navigate(`/coaching/courses`);
  }

  const handleStartPodcast = () => {
    if (podcast && podcast.id) {
      dispatch(startPodcast(podcast.id));
    }
  };

  const handleAnalyticsChange = (event: any) => {
    if (podcast && podcast.id && podcast.session && podcast.session.id) {
      const request: UpdatePodcastSessionRequest = {
        id: podcast.session!.id!,
        podcast: podcast.podcast!.id!,
        learningRecord: podcast.id,
        request: {
          dataPoints: event.analytics?.datapoints,
          sequence: new Date().getTime(),
          progress: event.analytics?.progress || 0,
          percentCompleted: event.analytics?.percentageRead || 0,
          duration: event.analytics?.duration || 0,
        },
      };

      dispatch(updatePodcastSession(request));
    }
  }

  if (!userRoleService.canAccessCoaching()) {
    return <PermissionDenined className={styles.permissionDenied} />;
  }

  if (podcastErrorCode === 10007) {
    return <CourseNotFound onBack={handleBackClicked} />
  }

  if ((loading && podcast?.id != id) || !podcast) {
    return (
      <LoadingPodcastPage onBack={handleBackClicked}/>
    );
  }

  return (
    <PodcastContext.Provider value={podcastContext}>
      <PodcastSummaryComponent podcast={podcast} />
    </PodcastContext.Provider>
  );
}